import { render, staticRenderFns } from "./Abonnement.vue?vue&type=template&id=56428bf5&scoped=true&"
import script from "./Abonnement.vue?vue&type=script&lang=js&"
export * from "./Abonnement.vue?vue&type=script&lang=js&"
import style0 from "./Abonnement.vue?vue&type=style&index=0&id=56428bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56428bf5",
  null
  
)

export default component.exports